/// <reference path="../../node_modules/moment/moment.d.ts" />

namespace Seac.Commons {
	/** Utility di conversione dei dati */
	export class ConvertTo {
		public static shortDatePattern	: string;
		public static longTimePattern	: string;

		private static _monthNameList : Array<string> = [
			Seac.Resources.Common.enum_mese_anno_gennaio,
			Seac.Resources.Common.enum_mese_anno_febbraio,
			Seac.Resources.Common.enum_mese_anno_marzo,
			Seac.Resources.Common.enum_mese_anno_aprile,
			Seac.Resources.Common.enum_mese_anno_maggio,
			Seac.Resources.Common.enum_mese_anno_giugno,
			Seac.Resources.Common.enum_mese_anno_luglio,
			Seac.Resources.Common.enum_mese_anno_agosto,
			Seac.Resources.Common.enum_mese_anno_settembre,
			Seac.Resources.Common.enum_mese_anno_ottobre,
			Seac.Resources.Common.enum_mese_anno_novembre,
			Seac.Resources.Common.enum_mese_anno_dicembre
		];

		private static _monthMeseAnnoFiltroDocumentiNameList: Array<string> = [
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_gennaio,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_febbraio,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_marzo,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_aprile,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_maggio,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_giugno,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_luglio,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_agosto,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_settembre,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_ottobre,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_novembre,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_dicembre,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_tredicesima,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_quattordicesima,
			Seac.Resources.Documento.enum_mese_anno_filtro_documenti_annuale
		];

		private static _dayNameList : Array<string> = [
			Seac.Resources.Common.enum_giorno_settimana_domenica,
			Seac.Resources.Common.enum_giorno_settimana_lunedi,
			Seac.Resources.Common.enum_giorno_settimana_martedi,
			Seac.Resources.Common.enum_giorno_settimana_mercoledi,
			Seac.Resources.Common.enum_giorno_settimana_giovedi,
			Seac.Resources.Common.enum_giorno_settimana_venerdi,
			Seac.Resources.Common.enum_giorno_settimana_sabato
		];

		/**
		 * Converte una stinga in formato ISO ISO8601 in un oggetto Date.
		 * Il formato ISO8601 è così composto:
		 * aaaa-mm-ggThh:mi:ss.mmm (senza spazi)
		 */
		public static stringIsoToDate(stringDate: string): Date {
			// 0         1         2
			// 01234567890123456789012
			// aaaa-mm-ggThh:mi:ss.mmm
			return new Date(
				+stringDate.substr(0, 4),
				(+stringDate.substr(5, 2)) - 1,
				+stringDate.substr(8, 2),

				+stringDate.substr(11, 2),
				+stringDate.substr(14, 2),
				+stringDate.substr(17, 2),

				(stringDate.length > 19 && !isNaN(<any>stringDate.substr(20)) ? +stringDate.substr(20) : 0)
			);
		}

		/**
		 * Converte la data in una stringa secondo il formato richiesto
		 * @param format Formato compatibile com la libreria Moment.js
		 */
		public static dateToString(date: Date, format: string): string {
			if (!date) {
				return null;
			}
			// TODO: Inserire moment per TypeScript
			return (<any>window).moment(date).format(format);
		}

		/**
		 * Converte una stinga in formato ISO ISO8601 in una stringa formattata secondo il formato richiesto
		 * @param format Formato compatibile com la libreria Moment.js
		 */
		public static stringIsoToString(stringDate: string, format: string): string {
			const date: Date = ConvertTo.stringIsoToDate(stringDate);
			return ConvertTo.dateToString(date, format);
		}

		/**
		 * Converte una stringa proveniente dal server in un oggetto data
		 * @param stringDate Stringa rappresentante la data da convertire
		 */
		public static stringToDate(stringDate: string): Date {
			const momentDate = (<any>window).moment(stringDate, `${this.shortDatePattern.toUpperCase()} ${this.longTimePattern}`);
			if (momentDate.isValid()) {
				return momentDate.toDate();
			}else {
				return null;
			}
		}

		/**
		 * Converte un valore numerico in una stringa formattata.
		 * Alcuni tipi di template supportati
		 * format( "#,##0.####", 1234567.890 );  // output: "1,234,567.89"
		 * format( "$ #,###.00", -1234567.890 ); // output: "$ -1,234,567.89"
		 * @param number Valore numerico da convertire
		 * @param template Template o maschera compatibile con Number Formatter ( https://github.com/Mottie/javascript-number-formatter/ ), se null verrà autilizzato il templete "#.#####"
		 * @param emptyIfZero Se true ed il valore è zero o nullo ritorna stringa vuota
		 */
		public static numberToString(number: number, template: string, emptyIfZero: boolean = false, emptyValue = ''): string {
			try {
				if (isNaN(number)) {
					number = 0;
				}
				if (emptyIfZero && !number) {
					return emptyValue;
				}
				return Seac.Commons.FormatNumber.format(template || '#.#####', number);
			}catch(ex) {
				console.error(ex);
				return <string><any>number;
			}
		}

		/**
		 * Restituisce il mese in stringa in base al suo valore numerico (in base 0)
		 * @param monthNumber Numero del mese (in base 0)
		 */
		public static numberToMonthString(monthNumber: number): string {
			return this._monthNameList[monthNumber];
		}

		/**
		 * Restituisce il mese in stringa in base al suo valore numerico (in base 0), considera anche
		 * tredicesima, quattordicesima e annuale
		 * @param monthNumber Numero del mese (in base 0)
		 */
		public static numberToMeseAnnoFiltroDocumentiString(monthNumber: number): string {
			return this._monthMeseAnnoFiltroDocumentiNameList[monthNumber];
		}

		/**
		 * Restituisce il giorno in stringa in base al suo valore numerico (in base 0)
		 * @param dayNumber Numero del giorno (in base 0)
		 */
		public static numberToDayString(dayNumber: number): string {
			return this._dayNameList[dayNumber];
		}

		/**
		 * Imposta l'orario di una data alla mezzanotte
		 * @param date Data di input (non verrà variata)
		 */
		public static dateToMidnight(date: Date): Date {
			const clonedDate: Date = new Date(date.getTime());
			clonedDate.setHours(0);
			clonedDate.setMinutes(0);
			clonedDate.setSeconds(0);
			clonedDate.setMilliseconds(0);
			return clonedDate;
		}
	}
}
